import { Controller } from "@hotwired/stimulus";

export default class HelpDeskController extends Controller {

  reply() {
    $("#new_help_ticket_reply")[0].requestSubmit();
  }

}
